import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { ClientService } from '../../../../services/clients';
import { get } from 'http';
import { CompaniesService } from '../../../../services/companies';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-allcompanies',
  templateUrl: './allcompanies.component.html',
  styleUrl: './allcompanies.component.scss'
})
export class AllcompaniesComponent {



  @Input() isProfile: string = "";

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';

  displayedColumns: string[] = [
    'name',
    'specialty',
    'industry',              // ✅ القطاع
    'address',
    'tel',
    'fax',                   // ✅ فاكس
    'contact_email',
    'facebook',              // ✅ فيسبوك
    'linkedin',              // ✅ لينكدإن
    'is_ahmed_elshahat_client', // ✅ فلاغ
    'options'
  ];


  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1')
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  isMobile: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,

    private _companies: CompaniesService,
    private _profileService: ProfileService,
    private deviceService: DeviceDetectorService,
    private excelExportService: ExcelExportService,
    private _userService: UserService,
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile) {
      this.displayedColumns = [
        'name',

        'tel',
        // ✅ لينكدإن
        'is_ahmed_elshahat_client', // ✅ فلاغ

      ];
    }
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
        if (!data['has_access_to_phone_numbers']) {
          const colsToRemove = ['tel', 'contact_email', 'facebook', 'linkedin'];
          this.displayedColumns = this.displayedColumns.filter(col => !colsToRemove.includes(col));
        }
        else {

          this.displayedColumns.push('add_by');
          this.displayedColumns.push('editor');
        }
        this.getAllClients(10, 1);

      },
      error: (error) => console.error(error),
    });


  }
  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._companies.search(this.searchKey).subscribe({
        next: (data) => {

          this.allData = data['data'];
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', 'AhmedElshahatClients', ['actions']);
  }
  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._companies.delete(id).subscribe({
          next: (res) => {
            this.getAllClients(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
  edit(itemobj: any) {
    this.router.navigate(['/createcompany'], { queryParams: itemobj });
  }
  getAllClients(perpage: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._companies.getAll(perpage, page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['last_page'];
        this.totalItems = data['total'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllClients(10, newPage);
  }


}